import imageCompression from "browser-image-compression";
import { supabase } from "@/integrations/supabase/client";

const TEN_YEARS = 60 * 60 * 24 * 365 * 10;

export async function uploadCompressedImage(
  file: File,
  folder: string = "misc"
): Promise<string> {
  const compressed = await imageCompression(file, {
    maxSizeMB: 0.4,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    fileType: "image/webp",
    initialQuality: 0.8,
  });

  const ext = "webp";
  const path = `${folder}/${crypto.randomUUID()}.${ext}`;

  const { error: upErr } = await supabase.storage
    .from("media")
    .upload(path, compressed, {
      contentType: "image/webp",
      cacheControl: "31536000",
      upsert: false,
    });
  if (upErr) throw upErr;

  const { data, error } = await supabase.storage
    .from("media")
    .createSignedUrl(path, TEN_YEARS);
  if (error || !data?.signedUrl) throw error ?? new Error("Could not sign URL");

  return data.signedUrl;
}
